import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { memo, useCallback, useMemo, useState } from "react";
import MainApi from "./../../../../../services/mainApi.service";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { IMarComAutomationLists } from "../../../../../models/mar-com-automation-list";
import { DistributionList } from "./DistributionListForm/DistributionList";

const List_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/MarComAutomationList/";
const ListService = new MainApi<IMarComAutomationLists>(List_ROUTE);

const translationPath =
  "page.4uMarCom.automationRules.marcom_distributionList.";

export const ListsPage = memo(() => {
  const [listForm, setListForm] = useState(false);

  const { id } = useParams();

  const [selectedId, setSelectedId] = useState<string>();

  const { t } = useTranslation();

  const columns: GridColDef<IMarComAutomationLists>[] = [
    {
      field: "list",
      headerName: t(translationPath + "list") || "List",
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={params.row.list.name}
            tooltip={params.row.list.name}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
  ];

  const handleAdd = () => {
    setListForm(true);
  };

  const handleRowClick = (params: GridRowParams<IMarComAutomationLists>) => {
    if (!params.row) return;
    setListForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setListForm(false);
  }, []);

  const props = useMemo(() => {
    return {
      MarComAutomationRuleId: id,
    };
  }, [id]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {listForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <DistributionList
            id={selectedId}
            marComAutomationRuleId={id}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!listForm && (
        <Box height={600}>
          <Table<IMarComAutomationLists>
            showDefaultMacroFilters={false}
            service={ListService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            serviceProps={props}
            searchInputPlaceHolder={
              t(translationPath + "search") || "Search for a list"
            }
            addButtonLabel={t(translationPath + "add_List") || "Add list"}
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
